<div class="tag-select-row" *ngIf="tags.length > 0">
  <span class="tag-label">{{ label }}</span>

  <div class="tag-select-control">
    <div class="tag-select-trigger" (click)="toggleDropdown($event)" [class.is-open]="isOpen">
      <div class="tag-chips-area">
        <span class="tag-placeholder" *ngIf="linkedTags.length === 0">{{ 'general.choose' | translate }}</span>
        <div class="tag-chip" *ngFor="let tag of linkedTags" (click)="removeTag(tag, $event)">
          <span class="chip-label">{{ tag.tag }}</span>
          <span class="chip-remove">&#x2715;</span>
        </div>
      </div>
      <div class="tag-chevron">
        <daz-icon [name]="isOpen ? 'chevron-up' : 'chevron-down'"
                  size="18px"
                  color="var(--hubtiger-secondary)">
        </daz-icon>
      </div>
    </div>

    <div class="tag-dropdown" *ngIf="isOpen" >
      <div class="tag-option"
           *ngFor="let tag of tags"
           (click)="toggleTag(tag)">
        <p-checkbox [binary]="true"
                    [ngModel]="isSelected(tag)"
                   >
        </p-checkbox>
        <span class="tag-option-label">{{ tag.tag }}</span>
      </div>
      <div class="tag-empty" *ngIf="tags.length === 0">
        <span>{{ 'general.no_data' | translate }}</span>
      </div>
    </div>
  </div>
</div>
